export default "/images/16cc07ef556700e661e8e54e84e87776.avif";